import { CtCatalogue } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'number',
      required: true
    },
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: true
    },
    aliases: {
      field: 'aliases',
      label: 'Aliases',
      validator: () => true,
      type: 'tag',
      required: false
    },
    print_slip: {
      field: 'print_slip',
      label: 'Print packing slip',
      validator: () => true,
      type: 'boolean',
      default: false,
      required: false
    },
    map: {
      field: 'map',
      label: 'Order Map',
      validator: () => true,
      contentType: 'datamap',
      type: 'link',
      default: false,
      required: false
    },
    client: {
      field: 'client',
      label: 'Client',
      validator: () => true,
      contentType: 'client',
      type: 'link',
      default: false,
      required: false
    },
    // packing_slip: {
    //   field: 'packing_slip',
    //   label: 'Packing slip',
    //   validator: () => true,
    //   type: 'string',
    //   required: false
    // },
    fix_fulfillment_tiers: {
      field: 'fix_fulfillment_tiers',
      label: 'Fix Fulfillment Tiers',
      validator: () => true,
      type: 'boolean',
      default: false,
      required: false
    },
    invoice_inventory: {
      field: 'invoice_inventory',
      label: 'Invoice Inventory',
      validator: () => true,
      type: 'boolean',
      default: false,
      required: false
    },
    invoice_by_storage_type: {
      field: 'invoice_by_storage_type',
      label: 'Invoice By Storage Type',
      validator: () => true,
      type: 'boolean',
      default: false,
      required: false
    },
    fulfillment_prices: {
      field: 'fulfillment_prices',
      label: 'Fulfillment Prices',
      validator: () => true,
      type: 'json',
      required: false
    },
    sku_prepend: {
      field: 'sku_prepend',
      label: 'SKU prepended value',
      validator: () => true,
      type: 'string',
      required: false
    },
    sku_separator: {
      field: 'sku_separator',
      label: 'SKU separator value',
      validator: () => true,
      type: 'string',
      required: false
    },
    sku_append: {
      field: 'sku_append',
      label: 'SKU appended value',
      validator: () => true,
      type: 'string',
      required: false
    },
    shipping_time: {
      field: 'shipping_time',
      label: 'Shipping Time',
      validator: () => true,
      type: 'string',
      required: false
    },
    shipping_carrier: {
      field: 'shipping_carrier',
      label: 'Shipping Carrier',
      validator: () => true,
      type: 'string',
      required: false
    }
    // service: {
    //   field: 'service',
    //   label: 'Pingback service configuration',
    //   validator: () => true,
    //   type: 'json',
    //   required: false
    // }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtCatalogue>(
  ContentType.Catalogue, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
